import i18n from '../services/i18n';

export default [
  {value: 'view_profile', label: i18n.t('view profile')},
  {value: 'update_twoFA', label: i18n.t('update twoFA')},
  {value: 'update_email', label: i18n.t('update email')},
  {value: 'view_user-kyc', label: i18n.t('view user kyc')},
  {value: 'update_user-suspension', label: i18n.t('update user suspension')},
  {value: 'update_user-kyc', label: i18n.t('update user kyc')},
  {value: 'view_user-bank-accounts', label: i18n.t('view user bank accounts')},
  {value: 'update_user-bank-accounts', label: i18n.t('update user bank accounts')},
  {value: 'create_user-bank-accounts', label: i18n.t('create user bank accounts')},
  {value: 'delete_user-bank-accounts', label: i18n.t('delete user bank accounts')},
  {value: 'view_user-wallets', label: i18n.t('view user wallets')},
  {value: 'view_user-deposits', label: i18n.t('view user deposits')},
  {value: 'update_user-unconfirmed-deposits', label: i18n.t('update user unconfirmed deposits')},
  {value: 'update_user-blocked-deposits', label: i18n.t('update user blocked deposits')},
  {value: 'view_user-withdraws', label: i18n.t('view user withdraws')},
  {value: 'delete_user-withdraws', label: i18n.t('cancel user withdraws')},
  {value: 'update_user-withdraw-status', label: i18n.t('update user withdraw status')},
  {value: 'view_user-trades', label: i18n.t('view user trades')},
  {value: 'view_user-orders', label: i18n.t('view user orders')},
  {value: 'update_user-open-orders', label: i18n.t('update user open orders')},
  {value: 'view_general-notifications', label: i18n.t('view general notifications')},
  {value: 'create_general-notifications', label: i18n.t('create general notifications')},
  {value: 'update_general-notifications', label: i18n.t('update general notifications')},
  {value: 'delete_general-notifications', label: i18n.t('delete general notifications')},
  {value: 'view_user-notifications', label: i18n.t('view user notifications')},
  {value: 'create_user-notifications', label: i18n.t('create user notifications')},
  {value: 'update_user-notifications', label: i18n.t('update user notifications')},
  {value: 'delete_user-notifications', label: i18n.t('delete user notifications')},
  {value: 'view_tickets', label: i18n.t('view tickets')},
  {value: 'update_tickets', label: i18n.t('update tickets')},
  {value: 'view_kyc-list', label: i18n.t('view kyc list')},
  {value: 'view_bank-accounts-list', label: i18n.t('view bank accounts list')},
  {value: 'view_deposits-list', label: i18n.t('view deposits list')},
  {value: 'view_withdraws-list', label: i18n.t('view withdraws list')},
  {value: 'view_unconfirmed-withdraws-list', label: i18n.t('view unconfirmed withdraws list')},
  {value: 'view_statistics', label: i18n.t('view statistics')},
  {value: 'create_admin-users', label: i18n.t('create admin users')},
  {value: 'update_admin-users', label: i18n.t('update admin users')},
  {value: 'delete_admin-users', label: i18n.t('delete admin users')},
  {value: 'view_admin-users', label: i18n.t('view admin users')},
  {value: 'view_rbac', label: i18n.t('view role based access control')},
  {value: 'update_rbac', label: i18n.t('update role based access control')},
  {value: 'view_mail-transport', label: i18n.t('View mail server settings')},
  {value: 'update_mail-transport', label: i18n.t('Update mail server settings')},
  {value: 'view_user-activities', label: i18n.t('View users login history')},
  {value: 'update_user-settings', label: i18n.t('Update user settings')},
  {value: 'update_user-phone-number', label: i18n.t('Update user mobile number')},
  {value: 'create_user-bank-deposit', label: i18n.t('Create user bank deposit')},
  {value: 'view_exchange-trades', label: i18n.t('View exchange trades')},
  {value: 'update_user-kyc-level-5', label: i18n.t('Update user kyc level to 5')},
  {value: 'view_policies', label: i18n.t('view policies')},
  {value: 'view_user-groups', label: i18n.t('view user groups')},
  {value: 'view_user-descriptions', label: i18n.t('view user descriptions')},
  {value: 'create_user-descriptions', label: i18n.t('create user descriptions')},
  {value: 'update_user-descriptions', label: i18n.t('update user descriptions')},
  {value: 'delete_user-descriptions', label: i18n.t('delete user descriptions')},
  // {value: 'view_financial-groups', label: i18n.t('view financial groups statistics')},
  {value: 'view_group-message', label: i18n.t('view group messages')},
  {value: 'create_group-message', label: i18n.t('create group message')},
  {value: 'view_user-referrals', label: i18n.t('view user referrals')},
  {value: 'create_user-referrals', label: i18n.t('create user referrals')},
  {value: 'update_user-referrals', label: i18n.t('update user referrals')},
  {value: 'delete_user-referrals', label: i18n.t('delete user referrals')},
  {value: 'create_network-address', label: i18n.t('create network address')},
  {value: 'view_gift', label: i18n.t('view gift cards')},
  {value: 'create_gift', label: i18n.t('create gift card')},
  {value: 'update_gift', label: i18n.t('update gift card')},
  {value: 'view_gift-stats', label: i18n.t('view gift card stats')},
  {value: 'create_user-orders', label: i18n.t('place order for user')},
  {value: 'create_transfer-wallet-balance', label: i18n.t('create wallet balance transfer')},
  {value: 'view_transfer-wallet-balance', label: i18n.t('view wallet balance transfers')},
  {value: 'update_transfer-wallet-balance', label: i18n.t('update wallet balance transfers')},
  {value: 'view_bonus-policy', label: i18n.t('view bonus cards')},
  {value: 'update_bonus-policy', label: i18n.t('update bonus card')},
  {value: 'create_bonus-policy', label: i18n.t('create bonus card')},
  {value: 'view_boards', label: i18n.t('view campaigns')},
  {value: 'update_boards', label: i18n.t('update campaign')},
  {value: 'create_boards', label: i18n.t('create campaign')},
  {value: 'view_bank-deposit', label: i18n.t('view bank deposits')},
  {value: 'update_bank-deposit', label: i18n.t('update bank deposit')},
  {value: 'view_notification', label: i18n.t('view notifications')},
  {value: 'create_notification', label: i18n.t('create notification')},
  {value: 'update_notification', label: i18n.t('update notification')},
  {value: 'delete_notification', label: i18n.t('delete notification')},
  {value: 'view_gateways', label: i18n.t('view gateways')},
  {value: 'update_withdraw-gateway-setting', label: i18n.t('Change withdraw gateway')},
  {value: 'update_deposit-gateway-setting', label: i18n.t('Change deposit gateway')},
  {value: 'view_tag', label: i18n.t('view tags'), onlyForSuperAdmin: true},
  {value: 'update_tag', label: i18n.t('update tag'), onlyForSuperAdmin: true},
  {value: 'create_tag', label: i18n.t('create tag'), onlyForSuperAdmin: true},
  {value: 'delete_tag', label: i18n.t('delete tag'), onlyForSuperAdmin: true},
  {value: 'view_zone', label: i18n.t('view zones'), onlyForSuperAdmin: true},
  {value: 'update_zone', label: i18n.t('update zone'), onlyForSuperAdmin: true},
  {value: 'create_zone', label: i18n.t('create zone'), onlyForSuperAdmin: true},
  {value: 'delete_zone', label: i18n.t('delete zone'), onlyForSuperAdmin: true},
];
